import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAutoCrop"><Path d="M18.85 14H18.15L17.275 16.275L15 17.15V17.85L17.275 18.725L18.15 21H18.85L19.725 18.725L22 17.85V17.15L19.725 16.275L18.85 14Z" fill="currentColor"/><Path d="M5.85 3H5.15L4.275 5.275L2 6.15V6.85L4.275 7.725L5.15 10H5.85L6.725 7.725L9 6.85V6.15L6.725 5.275L5.85 3Z" fill="currentColor"/><Path d="M11.5 4.5L20.5 4.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 12.5V19.5H12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAutoCrop;
